//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_METADATA_BASE_URL = new InjectionToken<string>('API_METADATA_BASE_URL');

@Injectable()
export class MetadataServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_METADATA_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5180";
    }

    config_Dump(): Observable<GetConfigDumpResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/dump";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_Dump(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_Dump(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigDumpResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigDumpResponse>;
        }));
    }

    protected processConfig_Dump(response: HttpResponseBase): Observable<GetConfigDumpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigDumpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_Versions(distro?: string | undefined): Observable<GetConfigVersionsResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/versions?";
        if (distro === null)
            throw new globalThis.Error("The parameter 'distro' cannot be null.");
        else if (distro !== undefined)
            url_ += "distro=" + encodeURIComponent("" + distro) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_Versions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_Versions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigVersionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigVersionsResponse>;
        }));
    }

    protected processConfig_Versions(response: HttpResponseBase): Observable<GetConfigVersionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigVersionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_GitRepos(distro?: string | undefined, version?: string | undefined): Observable<GetConfigGitReposResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/gitrepos?";
        if (distro === null)
            throw new globalThis.Error("The parameter 'distro' cannot be null.");
        else if (distro !== undefined)
            url_ += "distro=" + encodeURIComponent("" + distro) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_GitRepos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_GitRepos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigGitReposResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigGitReposResponse>;
        }));
    }

    protected processConfig_GitRepos(response: HttpResponseBase): Observable<GetConfigGitReposResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigGitReposResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_KojiTargets(): Observable<GetConfigKojiTargetsResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/kojitargets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_KojiTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_KojiTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigKojiTargetsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigKojiTargetsResponse>;
        }));
    }

    protected processConfig_KojiTargets(response: HttpResponseBase): Observable<GetConfigKojiTargetsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigKojiTargetsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_BuildEnvironment(name?: string | undefined): Observable<GetConfigBuildEnvironmentResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/buildenvironment?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_BuildEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_BuildEnvironment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigBuildEnvironmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigBuildEnvironmentResponse>;
        }));
    }

    protected processConfig_BuildEnvironment(response: HttpResponseBase): Observable<GetConfigBuildEnvironmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigBuildEnvironmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_BuildEnvironments(): Observable<GetConfigBuildEnvironmentsResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/buildenvironments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_BuildEnvironments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_BuildEnvironments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigBuildEnvironmentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigBuildEnvironmentsResponse>;
        }));
    }

    protected processConfig_BuildEnvironments(response: HttpResponseBase): Observable<GetConfigBuildEnvironmentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigBuildEnvironmentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_Resources(): Observable<GetConfigResourcesResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/resources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_Resources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_Resources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigResourcesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigResourcesResponse>;
        }));
    }

    protected processConfig_Resources(response: HttpResponseBase): Observable<GetConfigResourcesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigResourcesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_GetPublishChannels(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/metadata/config/publish/channels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_GetPublishChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_GetPublishChannels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processConfig_GetPublishChannels(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    config_GetKojiConfig(): Observable<GetConfigKojiResponse> {
        let url_ = this.baseUrl + "/api/metadata/config/koji";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_GetKojiConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_GetKojiConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigKojiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigKojiResponse>;
        }));
    }

    protected processConfig_GetKojiConfig(response: HttpResponseBase): Observable<GetConfigKojiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigKojiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metadata_GetVersion(): Observable<any> {
        let url_ = this.baseUrl + "/api/metadata/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata_GetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata_GetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMetadata_GetVersion(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metadata_ResolveRef(repoUri?: string | undefined, gitRef?: string | undefined): Observable<ResolveRefResponse> {
        let url_ = this.baseUrl + "/api/metadata/resolve-ref?";
        if (repoUri === null)
            throw new globalThis.Error("The parameter 'repoUri' cannot be null.");
        else if (repoUri !== undefined)
            url_ += "repoUri=" + encodeURIComponent("" + repoUri) + "&";
        if (gitRef === null)
            throw new globalThis.Error("The parameter 'gitRef' cannot be null.");
        else if (gitRef !== undefined)
            url_ += "gitRef=" + encodeURIComponent("" + gitRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata_ResolveRef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata_ResolveRef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveRefResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveRefResponse>;
        }));
    }

    protected processMetadata_ResolveRef(response: HttpResponseBase): Observable<ResolveRefResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResolveRefResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metadata_GetComponents(product_RepoUri?: string | undefined, product_Commit?: string | null | undefined, product_Branch?: string | null | undefined, product_Path?: string | undefined, project_RepoUri?: string | undefined, project_Commit?: string | null | undefined, project_Branch?: string | null | undefined, project_Path?: string | undefined): Observable<GetComponentsResponse> {
        let url_ = this.baseUrl + "/api/metadata/components?";
        if (product_RepoUri === null)
            throw new globalThis.Error("The parameter 'product_RepoUri' cannot be null.");
        else if (product_RepoUri !== undefined)
            url_ += "Product.RepoUri=" + encodeURIComponent("" + product_RepoUri) + "&";
        if (product_Commit !== undefined && product_Commit !== null)
            url_ += "Product.Commit=" + encodeURIComponent("" + product_Commit) + "&";
        if (product_Branch !== undefined && product_Branch !== null)
            url_ += "Product.Branch=" + encodeURIComponent("" + product_Branch) + "&";
        if (product_Path === null)
            throw new globalThis.Error("The parameter 'product_Path' cannot be null.");
        else if (product_Path !== undefined)
            url_ += "Product.Path=" + encodeURIComponent("" + product_Path) + "&";
        if (project_RepoUri === null)
            throw new globalThis.Error("The parameter 'project_RepoUri' cannot be null.");
        else if (project_RepoUri !== undefined)
            url_ += "Project.RepoUri=" + encodeURIComponent("" + project_RepoUri) + "&";
        if (project_Commit !== undefined && project_Commit !== null)
            url_ += "Project.Commit=" + encodeURIComponent("" + project_Commit) + "&";
        if (project_Branch !== undefined && project_Branch !== null)
            url_ += "Project.Branch=" + encodeURIComponent("" + project_Branch) + "&";
        if (project_Path === null)
            throw new globalThis.Error("The parameter 'project_Path' cannot be null.");
        else if (project_Path !== undefined)
            url_ += "Project.Path=" + encodeURIComponent("" + project_Path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata_GetComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata_GetComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetComponentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetComponentsResponse>;
        }));
    }

    protected processMetadata_GetComponents(response: HttpResponseBase): Observable<GetComponentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetComponentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metadata_GetChangedComponents(projectRepoUri?: string | undefined, projectPath?: string | undefined, fromRef?: string | undefined, toRef?: string | undefined): Observable<GetChangedComponentsResponse> {
        let url_ = this.baseUrl + "/api/metadata/components/changed?";
        if (projectRepoUri === null)
            throw new globalThis.Error("The parameter 'projectRepoUri' cannot be null.");
        else if (projectRepoUri !== undefined)
            url_ += "ProjectRepoUri=" + encodeURIComponent("" + projectRepoUri) + "&";
        if (projectPath === null)
            throw new globalThis.Error("The parameter 'projectPath' cannot be null.");
        else if (projectPath !== undefined)
            url_ += "ProjectPath=" + encodeURIComponent("" + projectPath) + "&";
        if (fromRef === null)
            throw new globalThis.Error("The parameter 'fromRef' cannot be null.");
        else if (fromRef !== undefined)
            url_ += "FromRef=" + encodeURIComponent("" + fromRef) + "&";
        if (toRef === null)
            throw new globalThis.Error("The parameter 'toRef' cannot be null.");
        else if (toRef !== undefined)
            url_ += "ToRef=" + encodeURIComponent("" + toRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata_GetChangedComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata_GetChangedComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetChangedComponentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetChangedComponentsResponse>;
        }));
    }

    protected processMetadata_GetChangedComponents(response: HttpResponseBase): Observable<GetChangedComponentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetChangedComponentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metadata_GetImages(product_RepoUri?: string | undefined, product_Commit?: string | null | undefined, product_Branch?: string | null | undefined, product_Path?: string | undefined, project_RepoUri?: string | undefined, project_Commit?: string | null | undefined, project_Branch?: string | null | undefined, project_Path?: string | undefined): Observable<GetImagesResponse> {
        let url_ = this.baseUrl + "/api/metadata/images?";
        if (product_RepoUri === null)
            throw new globalThis.Error("The parameter 'product_RepoUri' cannot be null.");
        else if (product_RepoUri !== undefined)
            url_ += "Product.RepoUri=" + encodeURIComponent("" + product_RepoUri) + "&";
        if (product_Commit !== undefined && product_Commit !== null)
            url_ += "Product.Commit=" + encodeURIComponent("" + product_Commit) + "&";
        if (product_Branch !== undefined && product_Branch !== null)
            url_ += "Product.Branch=" + encodeURIComponent("" + product_Branch) + "&";
        if (product_Path === null)
            throw new globalThis.Error("The parameter 'product_Path' cannot be null.");
        else if (product_Path !== undefined)
            url_ += "Product.Path=" + encodeURIComponent("" + product_Path) + "&";
        if (project_RepoUri === null)
            throw new globalThis.Error("The parameter 'project_RepoUri' cannot be null.");
        else if (project_RepoUri !== undefined)
            url_ += "Project.RepoUri=" + encodeURIComponent("" + project_RepoUri) + "&";
        if (project_Commit !== undefined && project_Commit !== null)
            url_ += "Project.Commit=" + encodeURIComponent("" + project_Commit) + "&";
        if (project_Branch !== undefined && project_Branch !== null)
            url_ += "Project.Branch=" + encodeURIComponent("" + project_Branch) + "&";
        if (project_Path === null)
            throw new globalThis.Error("The parameter 'project_Path' cannot be null.");
        else if (project_Path !== undefined)
            url_ += "Project.Path=" + encodeURIComponent("" + project_Path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata_GetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata_GetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetImagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetImagesResponse>;
        }));
    }

    protected processMetadata_GetImages(response: HttpResponseBase): Observable<GetImagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetImagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metadata_GetContainers(product_RepoUri?: string | undefined, product_Commit?: string | null | undefined, product_Branch?: string | null | undefined, product_Path?: string | undefined, project_RepoUri?: string | undefined, project_Commit?: string | null | undefined, project_Branch?: string | null | undefined, project_Path?: string | undefined): Observable<GetContainersResponse> {
        let url_ = this.baseUrl + "/api/metadata/containers?";
        if (product_RepoUri === null)
            throw new globalThis.Error("The parameter 'product_RepoUri' cannot be null.");
        else if (product_RepoUri !== undefined)
            url_ += "Product.RepoUri=" + encodeURIComponent("" + product_RepoUri) + "&";
        if (product_Commit !== undefined && product_Commit !== null)
            url_ += "Product.Commit=" + encodeURIComponent("" + product_Commit) + "&";
        if (product_Branch !== undefined && product_Branch !== null)
            url_ += "Product.Branch=" + encodeURIComponent("" + product_Branch) + "&";
        if (product_Path === null)
            throw new globalThis.Error("The parameter 'product_Path' cannot be null.");
        else if (product_Path !== undefined)
            url_ += "Product.Path=" + encodeURIComponent("" + product_Path) + "&";
        if (project_RepoUri === null)
            throw new globalThis.Error("The parameter 'project_RepoUri' cannot be null.");
        else if (project_RepoUri !== undefined)
            url_ += "Project.RepoUri=" + encodeURIComponent("" + project_RepoUri) + "&";
        if (project_Commit !== undefined && project_Commit !== null)
            url_ += "Project.Commit=" + encodeURIComponent("" + project_Commit) + "&";
        if (project_Branch !== undefined && project_Branch !== null)
            url_ += "Project.Branch=" + encodeURIComponent("" + project_Branch) + "&";
        if (project_Path === null)
            throw new globalThis.Error("The parameter 'project_Path' cannot be null.");
        else if (project_Path !== undefined)
            url_ += "Project.Path=" + encodeURIComponent("" + project_Path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata_GetContainers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata_GetContainers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContainersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContainersResponse>;
        }));
    }

    protected processMetadata_GetContainers(response: HttpResponseBase): Observable<GetContainersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContainersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    package_GetPackageRouting(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/metadata/publish/packages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPackage_GetPackageRouting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPackage_GetPackageRouting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processPackage_GetPackageRouting(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    package_GetPackageRoutingFromRpmMap(rpmSourceMap: RpmSourceMapEntry[]): Observable<AzlDevPackageRoutingEntry[]> {
        let url_ = this.baseUrl + "/api/metadata/publish/packages/from-rpm-map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rpmSourceMap);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPackage_GetPackageRoutingFromRpmMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPackage_GetPackageRoutingFromRpmMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AzlDevPackageRoutingEntry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AzlDevPackageRoutingEntry[]>;
        }));
    }

    protected processPackage_GetPackageRoutingFromRpmMap(response: HttpResponseBase): Observable<AzlDevPackageRoutingEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzlDevPackageRoutingEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class GetConfigDumpResponse implements IGetConfigDumpResponse {
    config?: DistroConfigDump;
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigDumpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.config = _data["config"] ? DistroConfigDump.fromJS(_data["config"]) : undefined as any;
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigDumpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigDumpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["config"] = this.config ? this.config.toJSON() : undefined as any;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigDumpResponse {
    config?: DistroConfigDump;
    metadata?: ConfigResponseMetadata;
}

export class DistroConfigDump implements IDistroConfigDump {
    distros?: { [key: string]: Distro; } | undefined;
    mockOptionsTemplates?: any | undefined;
    buildRootTemplates?: any | undefined;
    environments?: { [key: string]: DistroEnvironment; } | undefined;

    [key: string]: any;

    constructor(data?: IDistroConfigDump) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["distros"]) {
                this.distros = {} as any;
                for (let key in _data["distros"]) {
                    if (_data["distros"].hasOwnProperty(key))
                        (this.distros as any)![key] = _data["distros"][key] ? Distro.fromJS(_data["distros"][key]) : new Distro();
                }
            }
            this.mockOptionsTemplates = _data["mock-options-templates"];
            this.buildRootTemplates = _data["build-root-templates"];
            if (_data["environments"]) {
                this.environments = {} as any;
                for (let key in _data["environments"]) {
                    if (_data["environments"].hasOwnProperty(key))
                        (this.environments as any)![key] = _data["environments"][key] ? DistroEnvironment.fromJS(_data["environments"][key]) : new DistroEnvironment();
                }
            }
        }
    }

    static fromJS(data: any): DistroConfigDump {
        data = typeof data === 'object' ? data : {};
        let result = new DistroConfigDump();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.distros) {
            data["distros"] = {};
            for (let key in this.distros) {
                if (this.distros.hasOwnProperty(key))
                    (data["distros"] as any)[key] = this.distros[key] ? this.distros[key].toJSON() : undefined as any;
            }
        }
        data["mock-options-templates"] = this.mockOptionsTemplates;
        data["build-root-templates"] = this.buildRootTemplates;
        if (this.environments) {
            data["environments"] = {};
            for (let key in this.environments) {
                if (this.environments.hasOwnProperty(key))
                    (data["environments"] as any)[key] = this.environments[key] ? this.environments[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IDistroConfigDump {
    distros?: { [key: string]: Distro; } | undefined;
    mockOptionsTemplates?: any | undefined;
    buildRootTemplates?: any | undefined;
    environments?: { [key: string]: DistroEnvironment; } | undefined;

    [key: string]: any;
}

export class Distro implements IDistro {
    description?: string | undefined;
    versions?: { [key: string]: DistroVersion; } | undefined;

    constructor(data?: IDistro) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            if (_data["versions"]) {
                this.versions = {} as any;
                for (let key in _data["versions"]) {
                    if (_data["versions"].hasOwnProperty(key))
                        (this.versions as any)![key] = _data["versions"][key] ? DistroVersion.fromJS(_data["versions"][key]) : new DistroVersion();
                }
            }
        }
    }

    static fromJS(data: any): Distro {
        data = typeof data === 'object' ? data : {};
        let result = new Distro();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (this.versions) {
            data["versions"] = {};
            for (let key in this.versions) {
                if (this.versions.hasOwnProperty(key))
                    (data["versions"] as any)[key] = this.versions[key] ? this.versions[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IDistro {
    description?: string | undefined;
    versions?: { [key: string]: DistroVersion; } | undefined;
}

export class DistroVersion implements IDistroVersion {
    description?: string | undefined;
    releaseVer?: string | undefined;
    gitSourceRepos?: { [key: string]: GitSourceRepo[]; } | undefined;

    [key: string]: any;

    constructor(data?: IDistroVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
            this.releaseVer = _data["release-ver"];
            if (_data["git-source-repos"]) {
                this.gitSourceRepos = {} as any;
                for (let key in _data["git-source-repos"]) {
                    if (_data["git-source-repos"].hasOwnProperty(key))
                        (this.gitSourceRepos as any)![key] = _data["git-source-repos"][key] ? _data["git-source-repos"][key].map((i: any) => GitSourceRepo.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): DistroVersion {
        data = typeof data === 'object' ? data : {};
        let result = new DistroVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        data["release-ver"] = this.releaseVer;
        if (this.gitSourceRepos) {
            data["git-source-repos"] = {};
            for (let key in this.gitSourceRepos) {
                if (this.gitSourceRepos.hasOwnProperty(key))
                    (data["git-source-repos"] as any)[key] = (this.gitSourceRepos as any)[key];
            }
        }
        return data;
    }
}

export interface IDistroVersion {
    description?: string | undefined;
    releaseVer?: string | undefined;
    gitSourceRepos?: { [key: string]: GitSourceRepo[]; } | undefined;

    [key: string]: any;
}

export class GitSourceRepo implements IGitSourceRepo {
    ref?: string | undefined;
    defaultBranch?: string | undefined;
    defaultKojiRpmsTarget?: string | undefined;
    productPath?: string | undefined;
    projectPath?: string | undefined;

    constructor(data?: IGitSourceRepo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ref = _data["ref"];
            this.defaultBranch = _data["default-branch"];
            this.defaultKojiRpmsTarget = _data["default-koji-rpms-target"];
            this.productPath = _data["product-path"];
            this.projectPath = _data["project-path"];
        }
    }

    static fromJS(data: any): GitSourceRepo {
        data = typeof data === 'object' ? data : {};
        let result = new GitSourceRepo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ref"] = this.ref;
        data["default-branch"] = this.defaultBranch;
        data["default-koji-rpms-target"] = this.defaultKojiRpmsTarget;
        data["product-path"] = this.productPath;
        data["project-path"] = this.projectPath;
        return data;
    }
}

export interface IGitSourceRepo {
    ref?: string | undefined;
    defaultBranch?: string | undefined;
    defaultKojiRpmsTarget?: string | undefined;
    productPath?: string | undefined;
    projectPath?: string | undefined;
}

export class DistroEnvironment implements IDistroEnvironment {
    resources?: any | undefined;
    buildEnvironments?: { [key: string]: BuildEnvironment[]; } | undefined;
    resolvedKojiTargets?: ResolvedKojiTarget[] | undefined;

    [key: string]: any;

    constructor(data?: IDistroEnvironment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.resources = _data["resources"];
            if (_data["build-environments"]) {
                this.buildEnvironments = {} as any;
                for (let key in _data["build-environments"]) {
                    if (_data["build-environments"].hasOwnProperty(key))
                        (this.buildEnvironments as any)![key] = _data["build-environments"][key] ? _data["build-environments"][key].map((i: any) => BuildEnvironment.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["resolved-koji-targets"])) {
                this.resolvedKojiTargets = [] as any;
                for (let item of _data["resolved-koji-targets"])
                    this.resolvedKojiTargets!.push(ResolvedKojiTarget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistroEnvironment {
        data = typeof data === 'object' ? data : {};
        let result = new DistroEnvironment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["resources"] = this.resources;
        if (this.buildEnvironments) {
            data["build-environments"] = {};
            for (let key in this.buildEnvironments) {
                if (this.buildEnvironments.hasOwnProperty(key))
                    (data["build-environments"] as any)[key] = (this.buildEnvironments as any)[key];
            }
        }
        if (Array.isArray(this.resolvedKojiTargets)) {
            data["resolved-koji-targets"] = [];
            for (let item of this.resolvedKojiTargets)
                data["resolved-koji-targets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDistroEnvironment {
    resources?: any | undefined;
    buildEnvironments?: { [key: string]: BuildEnvironment[]; } | undefined;
    resolvedKojiTargets?: ResolvedKojiTarget[] | undefined;

    [key: string]: any;
}

export class BuildEnvironment implements IBuildEnvironment {
    name?: string;
    distro?: string;
    version?: string;
    repo?: string;
    repoUri?: string | undefined;
    productPath?: string | undefined;
    projectPath?: string | undefined;
    branch?: string;
    target?: string;
    type?: string;
    official?: boolean;

    constructor(data?: IBuildEnvironment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.distro = _data["distro"];
            this.version = _data["version"];
            this.repo = _data["repo"];
            this.repoUri = _data["repo-uri"];
            this.productPath = _data["product-path"];
            this.projectPath = _data["project-path"];
            this.branch = _data["branch"];
            this.target = _data["target"];
            this.type = _data["type"];
            this.official = _data["official"];
        }
    }

    static fromJS(data: any): BuildEnvironment {
        data = typeof data === 'object' ? data : {};
        let result = new BuildEnvironment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["distro"] = this.distro;
        data["version"] = this.version;
        data["repo"] = this.repo;
        data["repo-uri"] = this.repoUri;
        data["product-path"] = this.productPath;
        data["project-path"] = this.projectPath;
        data["branch"] = this.branch;
        data["target"] = this.target;
        data["type"] = this.type;
        data["official"] = this.official;
        return data;
    }
}

export interface IBuildEnvironment {
    name?: string;
    distro?: string;
    version?: string;
    repo?: string;
    repoUri?: string | undefined;
    productPath?: string | undefined;
    projectPath?: string | undefined;
    branch?: string;
    target?: string;
    type?: string;
    official?: boolean;
}

export class ResolvedKojiTarget implements IResolvedKojiTarget {
    name?: string;
    kind?: string | undefined;
    outputTag?: string | undefined;
    buildTag?: string | undefined;
    buildTagParent?: string | undefined;
    parentTag?: string | undefined;
    buildRoots?: BuildRoot[] | undefined;
    mockOptions?: string[] | undefined;
    externalRepos?: ExternalRepo[] | undefined;

    constructor(data?: IResolvedKojiTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kind = _data["kind"];
            this.outputTag = _data["output-tag"];
            this.buildTag = _data["build-tag"];
            this.buildTagParent = _data["build-tag-parent"];
            this.parentTag = _data["parent-tag"];
            if (Array.isArray(_data["build-roots"])) {
                this.buildRoots = [] as any;
                for (let item of _data["build-roots"])
                    this.buildRoots!.push(BuildRoot.fromJS(item));
            }
            if (Array.isArray(_data["mock-options"])) {
                this.mockOptions = [] as any;
                for (let item of _data["mock-options"])
                    this.mockOptions!.push(item);
            }
            if (Array.isArray(_data["external-repos"])) {
                this.externalRepos = [] as any;
                for (let item of _data["external-repos"])
                    this.externalRepos!.push(ExternalRepo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResolvedKojiTarget {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedKojiTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kind"] = this.kind;
        data["output-tag"] = this.outputTag;
        data["build-tag"] = this.buildTag;
        data["build-tag-parent"] = this.buildTagParent;
        data["parent-tag"] = this.parentTag;
        if (Array.isArray(this.buildRoots)) {
            data["build-roots"] = [];
            for (let item of this.buildRoots)
                data["build-roots"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mockOptions)) {
            data["mock-options"] = [];
            for (let item of this.mockOptions)
                data["mock-options"].push(item);
        }
        if (Array.isArray(this.externalRepos)) {
            data["external-repos"] = [];
            for (let item of this.externalRepos)
                data["external-repos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResolvedKojiTarget {
    name?: string;
    kind?: string | undefined;
    outputTag?: string | undefined;
    buildTag?: string | undefined;
    buildTagParent?: string | undefined;
    parentTag?: string | undefined;
    buildRoots?: BuildRoot[] | undefined;
    mockOptions?: string[] | undefined;
    externalRepos?: ExternalRepo[] | undefined;
}

export class BuildRoot implements IBuildRoot {
    type?: string;
    packages?: string[];

    constructor(data?: IBuildRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(item);
            }
        }
    }

    static fromJS(data: any): BuildRoot {
        data = typeof data === 'object' ? data : {};
        let result = new BuildRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item);
        }
        return data;
    }
}

export interface IBuildRoot {
    type?: string;
    packages?: string[];
}

export class ExternalRepo implements IExternalRepo {
    name?: string;
    url?: string;
    mergeMode?: string;

    constructor(data?: IExternalRepo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.mergeMode = _data["merge-mode"];
        }
    }

    static fromJS(data: any): ExternalRepo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalRepo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["merge-mode"] = this.mergeMode;
        return data;
    }
}

export interface IExternalRepo {
    name?: string;
    url?: string;
    mergeMode?: string;
}

export class ConfigResponseMetadata implements IConfigResponseMetadata {
    timestampUtc!: Date;
    commit!: string;
    branch!: string;

    constructor(data?: IConfigResponseMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestampUtc = _data["timestampUtc"] ? new Date(_data["timestampUtc"].toString()) : undefined as any;
            this.commit = _data["commit"];
            this.branch = _data["branch"];
        }
    }

    static fromJS(data: any): ConfigResponseMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigResponseMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestampUtc"] = this.timestampUtc ? this.timestampUtc.toISOString() : undefined as any;
        data["commit"] = this.commit;
        data["branch"] = this.branch;
        return data;
    }
}

export interface IConfigResponseMetadata {
    timestampUtc: Date;
    commit: string;
    branch: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class GetConfigVersionsResponse implements IGetConfigVersionsResponse {
    distro?: string;
    versions?: { [key: string]: DistroVersion; };
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigVersionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distro = _data["distro"];
            if (_data["versions"]) {
                this.versions = {} as any;
                for (let key in _data["versions"]) {
                    if (_data["versions"].hasOwnProperty(key))
                        (this.versions as any)![key] = _data["versions"][key] ? DistroVersion.fromJS(_data["versions"][key]) : new DistroVersion();
                }
            }
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigVersionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigVersionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distro"] = this.distro;
        if (this.versions) {
            data["versions"] = {};
            for (let key in this.versions) {
                if (this.versions.hasOwnProperty(key))
                    (data["versions"] as any)[key] = this.versions[key] ? this.versions[key].toJSON() : undefined as any;
            }
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigVersionsResponse {
    distro?: string;
    versions?: { [key: string]: DistroVersion; };
    metadata?: ConfigResponseMetadata;
}

export class GetConfigGitReposResponse implements IGetConfigGitReposResponse {
    distro?: string;
    version?: string;
    gitRepos?: { [key: string]: GitSourceRepo[]; };
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigGitReposResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distro = _data["distro"];
            this.version = _data["version"];
            if (_data["gitRepos"]) {
                this.gitRepos = {} as any;
                for (let key in _data["gitRepos"]) {
                    if (_data["gitRepos"].hasOwnProperty(key))
                        (this.gitRepos as any)![key] = _data["gitRepos"][key] ? _data["gitRepos"][key].map((i: any) => GitSourceRepo.fromJS(i)) : [];
                }
            }
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigGitReposResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigGitReposResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distro"] = this.distro;
        data["version"] = this.version;
        if (this.gitRepos) {
            data["gitRepos"] = {};
            for (let key in this.gitRepos) {
                if (this.gitRepos.hasOwnProperty(key))
                    (data["gitRepos"] as any)[key] = (this.gitRepos as any)[key];
            }
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigGitReposResponse {
    distro?: string;
    version?: string;
    gitRepos?: { [key: string]: GitSourceRepo[]; };
    metadata?: ConfigResponseMetadata;
}

export class GetConfigKojiTargetsResponse implements IGetConfigKojiTargetsResponse {
    kojiTargets?: ResolvedKojiTarget[];
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigKojiTargetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kojiTargets"])) {
                this.kojiTargets = [] as any;
                for (let item of _data["kojiTargets"])
                    this.kojiTargets!.push(ResolvedKojiTarget.fromJS(item));
            }
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigKojiTargetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigKojiTargetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kojiTargets)) {
            data["kojiTargets"] = [];
            for (let item of this.kojiTargets)
                data["kojiTargets"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigKojiTargetsResponse {
    kojiTargets?: ResolvedKojiTarget[];
    metadata?: ConfigResponseMetadata;
}

export class GetConfigBuildEnvironmentResponse implements IGetConfigBuildEnvironmentResponse {
    distro?: string;
    version?: string;
    buildEnvironment?: BuildEnvironment;
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigBuildEnvironmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distro = _data["distro"];
            this.version = _data["version"];
            this.buildEnvironment = _data["buildEnvironment"] ? BuildEnvironment.fromJS(_data["buildEnvironment"]) : undefined as any;
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigBuildEnvironmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigBuildEnvironmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distro"] = this.distro;
        data["version"] = this.version;
        data["buildEnvironment"] = this.buildEnvironment ? this.buildEnvironment.toJSON() : undefined as any;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigBuildEnvironmentResponse {
    distro?: string;
    version?: string;
    buildEnvironment?: BuildEnvironment;
    metadata?: ConfigResponseMetadata;
}

export class GetConfigBuildEnvironmentsResponse implements IGetConfigBuildEnvironmentsResponse {
    buildEnvironments?: BuildEnvironment[];
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigBuildEnvironmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildEnvironments"])) {
                this.buildEnvironments = [] as any;
                for (let item of _data["buildEnvironments"])
                    this.buildEnvironments!.push(BuildEnvironment.fromJS(item));
            }
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigBuildEnvironmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigBuildEnvironmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildEnvironments)) {
            data["buildEnvironments"] = [];
            for (let item of this.buildEnvironments)
                data["buildEnvironments"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigBuildEnvironmentsResponse {
    buildEnvironments?: BuildEnvironment[];
    metadata?: ConfigResponseMetadata;
}

export class GetConfigResourcesResponse implements IGetConfigResourcesResponse {
    environment?: string;
    resources?: any;
    metadata?: ConfigResponseMetadata;

    constructor(data?: IGetConfigResourcesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            this.resources = _data["resources"];
            this.metadata = _data["metadata"] ? ConfigResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigResourcesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigResourcesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        data["resources"] = this.resources;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigResourcesResponse {
    environment?: string;
    resources?: any;
    metadata?: ConfigResponseMetadata;
}

export class GetConfigKojiResponse implements IGetConfigKojiResponse {
    kojiInstance?: string;
    kojiFilesInstance?: string;

    constructor(data?: IGetConfigKojiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kojiInstance = _data["kojiInstance"];
            this.kojiFilesInstance = _data["kojiFilesInstance"];
        }
    }

    static fromJS(data: any): GetConfigKojiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigKojiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kojiInstance"] = this.kojiInstance;
        data["kojiFilesInstance"] = this.kojiFilesInstance;
        return data;
    }
}

export interface IGetConfigKojiResponse {
    kojiInstance?: string;
    kojiFilesInstance?: string;
}

export class ResolveRefResponse implements IResolveRefResponse {
    commit!: string;
    ref!: string;

    constructor(data?: IResolveRefResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commit = _data["commit"];
            this.ref = _data["ref"];
        }
    }

    static fromJS(data: any): ResolveRefResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveRefResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commit"] = this.commit;
        data["ref"] = this.ref;
        return data;
    }
}

export interface IResolveRefResponse {
    commit: string;
    ref: string;
}

export class GetComponentsResponse implements IGetComponentsResponse {
    metadata?: ResponseMetadata;
    components?: Component[];

    constructor(data?: IGetComponentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? ResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(Component.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetComponentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetComponentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetComponentsResponse {
    metadata?: ResponseMetadata;
    components?: Component[];
}

export class ResponseMetadata implements IResponseMetadata {
    timestampUtc!: Date;
    productCommit!: string;
    projectCommit!: string;

    constructor(data?: IResponseMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestampUtc = _data["timestampUtc"] ? new Date(_data["timestampUtc"].toString()) : undefined as any;
            this.productCommit = _data["productCommit"];
            this.projectCommit = _data["projectCommit"];
        }
    }

    static fromJS(data: any): ResponseMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestampUtc"] = this.timestampUtc ? this.timestampUtc.toISOString() : undefined as any;
        data["productCommit"] = this.productCommit;
        data["projectCommit"] = this.projectCommit;
        return data;
    }
}

export interface IResponseMetadata {
    timestampUtc: Date;
    productCommit: string;
    projectCommit: string;
}

export class Component implements IComponent {
    name?: string;

    constructor(data?: IComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Component {
        data = typeof data === 'object' ? data : {};
        let result = new Component();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IComponent {
    name?: string;
}

export class GetChangedComponentsResponse implements IGetChangedComponentsResponse {
    metadata?: ChangedComponentsMetadata;
    components?: ChangedComponentEntry[];

    constructor(data?: IGetChangedComponentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? ChangedComponentsMetadata.fromJS(_data["metadata"]) : undefined as any;
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ChangedComponentEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetChangedComponentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChangedComponentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetChangedComponentsResponse {
    metadata?: ChangedComponentsMetadata;
    components?: ChangedComponentEntry[];
}

export class ChangedComponentsMetadata implements IChangedComponentsMetadata {
    timestampUtc!: Date;
    fromCommit!: string;
    toCommit!: string;

    constructor(data?: IChangedComponentsMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestampUtc = _data["timestampUtc"] ? new Date(_data["timestampUtc"].toString()) : undefined as any;
            this.fromCommit = _data["fromCommit"];
            this.toCommit = _data["toCommit"];
        }
    }

    static fromJS(data: any): ChangedComponentsMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ChangedComponentsMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestampUtc"] = this.timestampUtc ? this.timestampUtc.toISOString() : undefined as any;
        data["fromCommit"] = this.fromCommit;
        data["toCommit"] = this.toCommit;
        return data;
    }
}

export interface IChangedComponentsMetadata {
    timestampUtc: Date;
    fromCommit: string;
    toCommit: string;
}

export class ChangedComponentEntry implements IChangedComponentEntry {
    component?: string;
    changeType?: string;
    sourcesChange?: boolean;

    [key: string]: any;

    constructor(data?: IChangedComponentEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.component = _data["component"];
            this.changeType = _data["changeType"];
            this.sourcesChange = _data["sourcesChange"];
        }
    }

    static fromJS(data: any): ChangedComponentEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ChangedComponentEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["component"] = this.component;
        data["changeType"] = this.changeType;
        data["sourcesChange"] = this.sourcesChange;
        return data;
    }
}

export interface IChangedComponentEntry {
    component?: string;
    changeType?: string;
    sourcesChange?: boolean;

    [key: string]: any;
}

export class GetImagesResponse implements IGetImagesResponse {
    metadata?: ResponseMetadata;
    images?: Image[];

    constructor(data?: IGetImagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? ResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(Image.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetImagesResponse {
    metadata?: ResponseMetadata;
    images?: Image[];
}

export abstract class ImageMetadataBase implements IImageMetadataBase {
    name?: string;
    description?: string | undefined;
    path?: string | undefined;
    profile?: string | undefined;
    testSuites?: string[];
    testSuiteDetails?: TestSuiteInfo[];
    architectures?: string[];

    constructor(data?: IImageMetadataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.path = _data["path"];
            this.profile = _data["profile"];
            if (Array.isArray(_data["testSuites"])) {
                this.testSuites = [] as any;
                for (let item of _data["testSuites"])
                    this.testSuites!.push(item);
            }
            if (Array.isArray(_data["testSuiteDetails"])) {
                this.testSuiteDetails = [] as any;
                for (let item of _data["testSuiteDetails"])
                    this.testSuiteDetails!.push(TestSuiteInfo.fromJS(item));
            }
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
        }
    }

    static fromJS(data: any): ImageMetadataBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ImageMetadataBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["path"] = this.path;
        data["profile"] = this.profile;
        if (Array.isArray(this.testSuites)) {
            data["testSuites"] = [];
            for (let item of this.testSuites)
                data["testSuites"].push(item);
        }
        if (Array.isArray(this.testSuiteDetails)) {
            data["testSuiteDetails"] = [];
            for (let item of this.testSuiteDetails)
                data["testSuiteDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        return data;
    }
}

export interface IImageMetadataBase {
    name?: string;
    description?: string | undefined;
    path?: string | undefined;
    profile?: string | undefined;
    testSuites?: string[];
    testSuiteDetails?: TestSuiteInfo[];
    architectures?: string[];
}

export class Image extends ImageMetadataBase implements IImage {

    constructor(data?: IImage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImage extends IImageMetadataBase {
}

export class TestSuiteInfo implements ITestSuiteInfo {
    name?: string;
    type?: string | undefined;
    suiteDefinition?: { [key: string]: any; } | undefined;

    constructor(data?: ITestSuiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (_data["suiteDefinition"]) {
                this.suiteDefinition = {} as any;
                for (let key in _data["suiteDefinition"]) {
                    if (_data["suiteDefinition"].hasOwnProperty(key))
                        (this.suiteDefinition as any)![key] = _data["suiteDefinition"][key];
                }
            }
        }
    }

    static fromJS(data: any): TestSuiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TestSuiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (this.suiteDefinition) {
            data["suiteDefinition"] = {};
            for (let key in this.suiteDefinition) {
                if (this.suiteDefinition.hasOwnProperty(key))
                    (data["suiteDefinition"] as any)[key] = (this.suiteDefinition as any)[key];
            }
        }
        return data;
    }
}

export interface ITestSuiteInfo {
    name?: string;
    type?: string | undefined;
    suiteDefinition?: { [key: string]: any; } | undefined;
}

export class GetContainersResponse implements IGetContainersResponse {
    metadata?: ResponseMetadata;
    containers?: Container[];

    constructor(data?: IGetContainersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? ResponseMetadata.fromJS(_data["metadata"]) : undefined as any;
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(Container.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContainersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContainersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetContainersResponse {
    metadata?: ResponseMetadata;
    containers?: Container[];
}

export class Container extends ImageMetadataBase implements IContainer {

    constructor(data?: IContainer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Container {
        data = typeof data === 'object' ? data : {};
        let result = new Container();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IContainer extends IImageMetadataBase {
}

export class AzlDevPackageRoutingEntry implements IAzlDevPackageRoutingEntry {
    packageName?: string;
    type?: string;
    group?: string;
    component?: string;
    publishChannel?: string;

    [key: string]: any;

    constructor(data?: IAzlDevPackageRoutingEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.packageName = _data["packageName"];
            this.type = _data["type"];
            this.group = _data["group"];
            this.component = _data["component"];
            this.publishChannel = _data["publishChannel"];
        }
    }

    static fromJS(data: any): AzlDevPackageRoutingEntry {
        data = typeof data === 'object' ? data : {};
        let result = new AzlDevPackageRoutingEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["packageName"] = this.packageName;
        data["type"] = this.type;
        data["group"] = this.group;
        data["component"] = this.component;
        data["publishChannel"] = this.publishChannel;
        return data;
    }
}

export interface IAzlDevPackageRoutingEntry {
    packageName?: string;
    type?: string;
    group?: string;
    component?: string;
    publishChannel?: string;

    [key: string]: any;
}

export class RpmSourceMapEntry implements IRpmSourceMapEntry {
    packageName?: string;
    sourcePackageName?: string;

    constructor(data?: IRpmSourceMapEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            this.sourcePackageName = _data["sourcePackageName"];
        }
    }

    static fromJS(data: any): RpmSourceMapEntry {
        data = typeof data === 'object' ? data : {};
        let result = new RpmSourceMapEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        data["sourcePackageName"] = this.sourcePackageName;
        return data;
    }
}

export interface IRpmSourceMapEntry {
    packageName?: string;
    sourcePackageName?: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}